<script lang="ts" setup>
const props = defineProps<{
  data: {
    id: number
    items: {
      block_project_stats_item_id: {
        id: number
        counter: string
        show_plus_sign: true
        video: DirectusFile
        translations: DirectusTranslation<{
          description: string
        }>
      }
    }[]
  }
}>()

const { dt } = useDirectusTranslation()

const stats = props.data.items.map((item) => {
  return {
    ...item.block_project_stats_item_id,
    description: dt(item.block_project_stats_item_id.translations)?.description,
    translations: undefined,
  }
})
</script>

<template>
  <BlockBase class="py-15rem">
    <Container class="grid grid-cols-1 gap-4rem lg:grid-cols-3">
      <BlockProjectStatsItem v-for="stat in stats" :key="stat.id" :data="stat" />
    </Container>
  </BlockBase>
</template>

<style>

</style>
